import { Column, Columns, Heading, Box } from 'braid-design-system';
import { IconCertified } from '../Icons/IconCertified/IconCertified';
import { observer } from 'mobx-react';
import { CertsyBrandTooltipContent } from './CertsyBrandTooltipContent';

interface Props {
  title: string;
  showTick?: boolean;
}

export const CertsyTooltipHeading = observer(
  ({ title, showTick = true }: Props) => (
    <Box marginBottom="xsmall">
      <Columns space="xsmall" align="left" alignY="top">
        {showTick ? (
          <Column width="content">
            <Heading component="span" level="3">
              <IconCertified />
            </Heading>
          </Column>
        ) : null}
        <Column>
          <Columns alignY="center" space="none">
            <Column>
              <Heading component="span" level="4">
                {title}
              </Heading>
            </Column>
            <Box paddingRight="xsmall">
              <Column width="content">
                <CertsyBrandTooltipContent />
              </Column>
            </Box>
          </Columns>
        </Column>
      </Columns>
    </Box>
  ),
);
